import moment from 'moment';

export function formatChatItemDate(timestamp: number): string {
  return moment(timestamp).format('DD MMM YYYY, HH:mm');
}
